import { Stack, Image, Box, Text, useColorModeValue as mode } from "@chakra-ui/react";
import Number from "components/number-format";

type OrderSummaryProductProps = {
    image: string,
    name: string,
    quantity: number,
    amount: number
}

const OrderItem = (props: OrderSummaryProductProps) => {
    const { image, name, quantity, amount } = props;
    return (
        <Stack direction="row" spacing="5" width="full">
            <Image
                rounded="lg"
                width="120px"
                height="120px"
                fit="cover"
                src={image}
                alt={name}
                draggable="false"
                loading="lazy"
            />
            <Box pt="4">
                <Stack spacing="0.5">
                    <Text fontWeight="semibold" fontSize={'sm'}>{name}</Text>
                    <Text color={mode('gray.600', 'gray.400')} fontSize="sm">
                        Qty: {quantity}
                    </Text>
                    <Text fontWeight="semibold" fontSize={'sm'}>
                        <Number displayType={"text"} prefix={"Rp "} value={amount} />
                    </Text>
                </Stack>
            </Box>
        </Stack>
    );
};

export default OrderItem;